import React, { useState, useEffect } from 'react';
import './styles.scss';

export default function TabelaRede2({ source }) {
  const [tabelaRede, setTabelaRede] = useState(null);

  useEffect(() => {
    if (!source?.vendedores) return;

    setTabelaRede(source);
  }, [source]);

  if (!tabelaRede) return null;

  return (
    <div className="row m-0">
      <h1 className="h3 mb-2 text-gray-800">Resumo Mensal por Vendedor</h1>
      <div className="card-header py-3">
        <h6 className="m-0 font-weight-bold text-primary"></h6>
      </div>
      <div className="card-body">
        <div className="table-responsive">
          <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
            <thead>
              <tr>
                <th>VENDEDOR</th>
                <th>META VENDEDOR</th>
                <th>TOTAL PEDIDO</th>
                <th>% PEDIDO</th>
                <th>PARCIAL+FATURADO</th>
                <th>% FATURADO</th>
                <th>PARCIAL</th>
                <th>RUPTURA</th>
                <th>TOTAL NÃO FATURADO</th>
              </tr>
            </thead>
            <tbody>
              {tabelaRede.vendedores.map((vendedor, index) => (
                <tr key={index}>
                  <td>{vendedor.vendedor}</td>
                  <td>
                    {vendedor.meta > 0
                      ? vendedor.meta.toLocaleString('pt-br', {
                          style: 'currency',
                          currency: 'BRL'
                        })
                      : '-'}
                  </td>
                  <td>
                    {vendedor.valorTotal.toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL'
                    })}
                  </td>
                  <td>
                    {vendedor.meta > 0 ? (
                      <div className="progress">
                        <div
                          className="progress-bar"
                          role="progressbar"
                          style={{
                            width: `${Math.trunc((vendedor.valorTotal * 100) / vendedor.meta)}%`
                          }}
                          aria-valuenow={Math.trunc((vendedor.valorTotal * 100) / vendedor.meta)}
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                        {Math.trunc((vendedor.valorTotal * 100) / vendedor.meta)}%
                      </div>
                    ) : (
                      <span>-</span>
                    )}
                  </td>
                  <td>
                    {(vendedor.valorFaturado + vendedor.valorParcial).toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL'
                    })}
                  </td>
                  <td>
                    {vendedor.meta > 0 ? (
                      <div className="progress">
                        <div
                          className="progress-bar"
                          role="progressbar"
                          style={{
                            width: `${Math.trunc(((vendedor.valorFaturado + vendedor.valorParcial) * 100) / vendedor.meta)}%`
                          }}
                          aria-valuenow={Math.trunc(
                            ((vendedor.valorFaturado + vendedor.valorParcial) * 100) / vendedor.meta
                          )}
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                        {Math.trunc(
                          ((vendedor.valorFaturado + vendedor.valorParcial) * 100) / vendedor.meta
                        )}
                        %
                      </div>
                    ) : (
                      <span>-</span>
                    )}
                  </td>
                  <td>
                    {vendedor.valorParcial.toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL'
                    })}
                  </td>
                  <td>
                    {vendedor.valorRuptura.toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL'
                    })}
                  </td>
                  <td>
                    {vendedor.valorNaoFaturado.toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL'
                    })}
                  </td>
                </tr>
              ))}

              <tr>
                <td>{tabelaRede.total.vendedor}</td>
                <td>
                  {tabelaRede.total.meta > 0
                    ? tabelaRede.total.meta.toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL'
                      })
                    : '-'}
                </td>
                <td>
                  {tabelaRede.total.valorTotal.toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL'
                  })}
                </td>
                <td>
                  {tabelaRede.total.meta > 0 ? (
                    <div className="progress">
                      <div
                        className="progress-bar"
                        role="progressbar"
                        style={{
                          width: `${Math.trunc((tabelaRede.total.valorTotal * 100) / tabelaRede.total.meta)}%`
                        }}
                        aria-valuenow={Math.trunc(
                          (tabelaRede.total.valorTotal * 100) / tabelaRede.total.meta
                        )}
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                      {Math.trunc((tabelaRede.total.valorTotal * 100) / tabelaRede.total.meta)}%
                    </div>
                  ) : (
                    <span>-</span>
                  )}

                  {/* <div className="progress">
                    <div className="progress-bar" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
                  </div> */}
                </td>
                <td>
                  {(tabelaRede.total.valorFaturado + tabelaRede.total.valorParcial).toLocaleString(
                    'pt-br',
                    { style: 'currency', currency: 'BRL' }
                  )}
                </td>
                <td>
                  {tabelaRede.total.meta > 0 ? (
                    <div className="progress">
                      <div
                        className="text-center progress-bar"
                        role="progressbar"
                        style={{
                          width: `${Math.trunc(((tabelaRede.total.valorFaturado + tabelaRede.total.valorParcial) * 100) / tabelaRede.total.meta)}%`
                        }}
                        aria-valuenow={Math.trunc(
                          ((tabelaRede.total.valorFaturado + tabelaRede.total.valorParcial) * 100) /
                            tabelaRede.total.meta
                        )}
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                      {Math.trunc(
                        ((tabelaRede.total.valorFaturado + tabelaRede.total.valorParcial) * 100) /
                          tabelaRede.total.meta
                      )}
                      %
                    </div>
                  ) : (
                    <span>-</span>
                  )}
                </td>
                <td>
                  {tabelaRede.total.valorParcial.toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL'
                  })}
                </td>
                <td>
                  {tabelaRede.total.valorRuptura.toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL'
                  })}
                </td>
                <td>
                  {tabelaRede.total.valorNaoFaturado.toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL'
                  })}
                </td>
              </tr>
            </tbody>
          </table>
          {/* <div className="total">
              <strong>Total Salary:</strong> {totalSalary.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
            </div> */}
        </div>
      </div>
    </div>
  );
}
